import { Component, OnInit, ViewChild, Inject, AfterViewInit } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MAT_DIALOG_DATA,
} from '@angular/material';
import { OrderService } from '../../../services/order/order.service';
import { TripService } from '../../../services/trip/trip.service';
import { TokenStorage } from '../../../auth/token.storage';
import { AngularFireDatabase } from '@angular/fire/database';
import { AllorderdetailsComponent } from '../../order/allorderdetails/allorderdetails.component';
import { NotifierService } from 'angular-notifier';
declare const google: any;

@Component({
  selector: 'app-tripdetails',
  templateUrl: './tripdetails.component.html',
  styleUrls: ['./tripdetails.component.scss']
})
export class TripdetailsComponent implements OnInit, AfterViewInit {
  public lat: Number = 18.552307
  public lng: Number = 73.724519
  public location: string

  public origin: {};

  public destination: {};
  public waypoints = [];
  tripName: string;
  public zoom: number = 13;
  newlocationArray: any[];
  pathForRoads: any;

  packageDetailsColumnDisplay = [
    'invoiceNo',
    'receiverDetails',
    'serialNumber',
    'packageDetails',
    'orderState',
    'orderStateInTransit'
  ];
  orderDetailsArray = new MatTableDataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  tripId: number;
  ordersByTripIdArray = [];
  productArrayInSelectedOrder = [];
  productInputDisplayArray = [];
  markersArr = [];
  tripStatus: string;
  destinationAddress: string;
  originAddress: string;
  zone: string;
  totalNumberOfOrders: string;
  tripDate: string;
  tripCreatedDate: string;
  inScheduled: boolean = false;
  inTransit: boolean = false;
  completed: boolean = false;
  vehicleLicenseNumber: string;
  vehicleType: string;
  tripStartTime: string;
  tripStopTime: string;
  driverName: string;
  helperName: string;
  mobileNumber: string;
  receiverDetailsArray = [];
  map: any;
  locationsArray: any[];
  deliveredOrderLocation: any[];
  tripStartedStopped = [];
  inTransitLocation = [];
  originDest = [];
  totalweightcapacity: string;
  totalvolumecapacity: string;
  odometerReadingStart: any;
  odometerReadingStop: any;
  public renderOptions = {
    suppressMarkers: true,
  };
  ispackageDetails = false;
  tat: string;
  isTenantDiag = false;
  isBajaj: boolean = false;

  mapstyles = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8ec3b9"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1a3646"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#64779e"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#334e87"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#6f9ba5"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3C7680"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#304a7d"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2c6675"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#255763"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#b0d5ce"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3a4762"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0e1626"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#4e6d70"
        }
      ]
    }
  ];

  /* 
    markerOpts = {
      destination: {
        icon: '../../../../assets/icons/truck1.png',
      },
      origin: {
        icon: '../../../../assets/icons/33622.png',
      },
    }; */
  icon = '../../../../assets/icons/truck1.png';
  isKohinoor: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public tripService: TripService,
    public orderService: OrderService,
    public db: AngularFireDatabase,
    private token: TokenStorage,
    private dialog: MatDialog,
    private notifierService: NotifierService) {
    if (this.token.getTenant() === 'kohinoor-reta-prod') {
      this.isKohinoor = true;
    }

    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      this.mapstyles = null;
    }
  }

  ngOnInit() {
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test')
      this.isBajaj = true;
    console.log(this.data)
    if (this.data.component == 'tripreport' || this.data.component == 'userreport') {
      this.tripService.getTripById(this.data.tripid).subscribe(tripdata => {
        this.data.data = tripdata;
        console.log(this.data);
        this.locationsArray = [];
        this.tripDetails();
      })
    }
    else
      this.tripDetails();

  }

  tripDetails() {
    this.tripService.getOrdersTripById(this.data.data.tripId).subscribe(orders => {
      console.log("orders In trip of tripid" + " " + this.data.data.tripId, orders)
      this.ordersByTripIdArray = orders;
      this.getAllProductsFromOrdersInTrip();
      if (this.data.data.tState === "TRIP_STATE_IN_TRANSIT" || this.data.data.tState === "TRIP_STATE_COMPLETED") {
        this.zoom = 13;
        let path = '/' + this.token.getTenant() + '/' + this.data.data.tripName;
        this.db.list(path).valueChanges().subscribe(res => {
          this.originDest = [];
          if (res.length > 0) {
            this.markersArr = res;
            this.originDest.push(this.markersArr[0]);
            this.originDest.push(this.markersArr[res.length - 1]);
            this.originDest[0].icon = '../../../../assets/icons/warehouse1.png';
            this.originDest[0].startStopStatus = "Trip Start";

            if (this.data.data.tState === "TRIP_STATE_IN_TRANSIT") {
              this.originDest[1].driver = this.driverName;
              if (this.isTenantDiag) {
                this.originDest[1].icon = '../../../../assets/icons/bike3d.png';
              } else {
                this.originDest[1].icon = '../../../../assets/icons/truck3d.png';
              }
            } else if (this.data.data.tState === "TRIP_STATE_COMPLETED") {
              this.originDest[1].startStopStatus = "Trip End";
            }

            this.locationsArray = res;
            console.log("locationsArray", this.locationsArray);
            this.deliveredOrderLocation = this.locationsArray.filter
              (deliveredLocations => deliveredLocations.status == 'delivered' || deliveredLocations.status == 'undelivered');
            let sequence = 1;
            this.deliveredOrderLocation.forEach(location => {
              location.seq = sequence.toString();
              sequence = sequence + 1;
              if (location.status == 'delivered') {
                location.deliveredIcon = "../../../../assets/icons/green.png";
                if (this.isTenantDiag) {
                  location.deliveryStatus = "Picked";
                } else {
                  location.deliveryStatus = "Delivered";
                }
              } else {
                if (this.isTenantDiag) {
                  location.deliveryStatus = "Pick Up Failed";
                } else {
                  location.deliveryStatus = "Delivery Failed";
                }
              }
            });

            this.deliveredUndeliveredAdress();
            this.locationsArray = this.locationsArray.filter(point => !point.hasOwnProperty('status'));
            if (this.locationsArray) {
              this.waypoints = [];
              if (this.locationsArray.length <= (22 - this.deliveredOrderLocation.length)) {
                this.locationsArray.forEach(loc => {
                  this.waypoints.push({
                    location: (parseFloat(loc.latitude) + "," + parseFloat(loc.longitude))
                  });
                });
              }
              else {
                this.waypoints = [];
                let i = 0;
                let multiplicationfactor: number = Number(this.locationsArray.length) / 23 - (this.deliveredOrderLocation.length);

                if (multiplicationfactor <= 1)
                  multiplicationfactor = 1;
                else
                  multiplicationfactor = parseInt(multiplicationfactor.toString())
                console.log("multifactor", multiplicationfactor);

                for (i = 0; i < this.locationsArray.length; i = i + multiplicationfactor) {

                  if (this.waypoints.length <= 22 - this.deliveredOrderLocation.length) {
                    this.waypoints.push({
                      location: (parseFloat(this.locationsArray[i].latitude) + "," + parseFloat(this.locationsArray[i].longitude))
                    });
                  }
                }
              }

              this.deliveredOrderLocation.forEach(loc => {
                this.waypoints.push({ location: (parseFloat(loc.latitude) + "," + parseFloat(loc.longitude)) })
              });
              this.origin = {
                lat: parseFloat(this.markersArr[0].latitude),
                lng: parseFloat(this.markersArr[0].longitude)
              };
              this.destination = {
                lat: parseFloat(this.markersArr[res.length - 1].latitude),
                lng: parseFloat(this.markersArr[res.length - 1].longitude)
              };
              if (this.markersArr.length != 0) {
                setTimeout(() => {
                  this.map.setZoom(13);
                }, 500);
              }

              console.log("waypoints,origin and destination", this.waypoints, this.origin, this.destination);

            }
          }

        });
      }
    });


    console.log("trip data", this.data.data)
    this.tripId = this.data.data.tripId;
    this.tripName = this.data.data.tripName;
    this.tripStatus = (this.data.data.tState).slice(11);
    this.destinationAddress = this.data.data.destinationAddress;
    this.originAddress = this.data.data.originAddress;
    this.zone = this.data.data.tripZone;
    this.totalNumberOfOrders = this.data.data.totalNumberOfOrders;
    this.tripDate = this.data.data.tripCreatedDateTime;
    this.tripCreatedDate = this.data.data.tripCreatedDateTime;
    this.totalvolumecapacity = this.data.data.totalVolume;
    this.totalweightcapacity = this.data.data.totalWeight;

    if (this.data.data.tState === "TRIP_STATE_SCHEDULED") {
      this.inScheduled = true;
    } else if (this.data.data.tState === "TRIP_STATE_IN_TRANSIT") {
      this.inTransit = true;
      this.tripStartTime = this.data.data.tripActualStartDateTime;
      this.odometerReadingStart = this.data.data.odometerReadingStart;
    } else if (this.data.data.tState === "TRIP_STATE_COMPLETED") {
      this.completed = true;
      this.tripStartTime = this.data.data.tripActualStartDateTime;
      this.tripStopTime = this.data.data.tripActualEndDateTime;
      this.odometerReadingStart = this.data.data.odometerReadingStart;
      this.odometerReadingStop = this.data.data.odometerReadingEnd;
      let tatInMiliSecond = new Date(this.tripStopTime).getTime() - new Date(this.tripStartTime).getTime();
      this.tat = this.tripService.getFormattedTime(tatInMiliSecond);
    }

    if (this.inScheduled || this.inTransit || this.completed) {
      if (this.isKohinoor && this.data.data.helperName)
        this.helperName = this.data.data.helperName;
      this.vehicleLicenseNumber = this.data.data.fleet.vehicleLicenseNumber;
      this.vehicleType = this.data.data.vehicleType;
      this.driverName = this.data.data.driver.firstName + " ";
      if (this.data.data.driver.lastName)
        this.driverName += this.data.data.driver.lastName;
      this.mobileNumber = this.data.data.driver.phoneNumber1;
    }

  }

  deliveredUndeliveredAdress() {
    console.log("called", this.deliveredOrderLocation)
    if (!this.isTenantDiag) {
      this.deliveredOrderLocation.forEach(order => {
        let findOrder = this.ordersByTripIdArray.find(d => d.orderInvoiceNumber == order.orderId);
        if (findOrder) {
          let houseno, area, city, landmark, pincode;

          if (!findOrder.destinationAddress.houseNumber)
            houseno = '';
          else
            houseno = findOrder.destinationAddress.houseNumber;
          if (!findOrder.destinationAddress.area)
            area = '';
          else
            area = findOrder.destinationAddress.area;
          if (!findOrder.destinationAddress.city)
            city = '';
          else
            city = findOrder.destinationAddress.city;
          if (!findOrder.destinationAddress.landmark)
            landmark = '';
          else
            landmark = findOrder.destinationAddress.landmark;
          if (!findOrder.destinationAddress.pincode)
            pincode = '';
          else
            pincode = findOrder.destinationAddress.pincode;
          order.addr = houseno + "  " + area + "  " + city + "  " + landmark + "  " + pincode;
        }
      });
    }
    else if (this.isTenantDiag) {
      this.deliveredOrderLocation.forEach(order => {
        let findOrder = this.ordersByTripIdArray.find(d => d.orderInvoiceNumber == order.orderId);
        let houseno, area, city, landmark, pincode;
        if (findOrder) {
          if (!findOrder.originAddress.houseNumber)
            houseno = '';
          else
            houseno = findOrder.originAddress.houseNumber;
          if (!findOrder.originAddress.area)
            area = '';
          else
            area = findOrder.originAddress.area;
          if (!findOrder.originAddress.city)
            city = '';
          else
            city = findOrder.originAddress.city;
          if (!findOrder.originAddress.landmark)
            landmark = '';
          else
            landmark = findOrder.originAddress.landmark;
          if (!findOrder.originAddress.pincode)
            pincode = '';
          else
            pincode = findOrder.originAddress.pincode;
          order.addr = houseno + "  " + area + "  " + city + "  " + landmark + "  " + pincode;
        }
      });
    }
  }

  completedTripMap() {
    this.deliveredOrderLocation = this.locationsArray.filter
      (deliveredLocations => deliveredLocations.status == 'delivered');
    this.locationsArray[0].point = 'Start Point'
    this.locationsArray[this.locationsArray.length - 1].point = 'End Point'

    this.deliveredOrderLocation.push(this.locationsArray[0], this.locationsArray[this.locationsArray.length - 1])

  }

  findAddressUsingLatLng(array) {
    for (let j = 0; j < array.length; j++) {
      let geocoder = new google.maps.Geocoder();
      let latlng = { lat: array[j].latitude, lng: array[j].longitude };
      geocoder.geocode({ 'location': latlng }, (results) => {
        if (results[1])
          array[j].addr = results[1].formatted_address;
      });
    }
    return array;
  }

  mapReady(map) {
    this.map = map;
  }

  getAllProductsFromOrdersInTrip() {
    if (this.ordersByTripIdArray != null) {
      for (let i = 0; i < this.ordersByTripIdArray.length; i++) {
        this.orderService.getAllProductsInOrder(this.ordersByTripIdArray[i].orderUniqueId).subscribe(products => {
          this.ordersByTripIdArray[i].products = products;
        }, Error => {
          console.log(Error);
        })
      }
    }
  }


  nullCheck(field) {
    if (!field)
      return "";
    return field;
  }

  ngAfterViewInit() {
    this.zoom = 13;
  }

  tabChanged(Event) {
    console.log(Event.index);
  }

  orderDetails(order, event) {
    event.stopPropagation();
    let editDialog = this.dialog.open(AllorderdetailsComponent, {
      width: '800px',
      data: {
        data: {
          orderInfo: order,
          prodQList: order.products
        }
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }


  stopEnter(event) {
    console.log(event.which)
    if (event.which == 13) {
      event.preventDefault();
    }
  }

  changeSerialNum(event, oid, pid) {
    let finalSerialNum = [], orderChanged = { prodQList: [], orderInfo: {} };
    /*  event.preventDefault();
     event.stopPropagation(); */
    if (event.keyCode == 13 && event.target.textContent.split(',')[0] != ' - ') {
      console.log(event.target.textContent.split(','))
      let serialno = event.target.textContent.split(',');
      let isInvalid: boolean = false;
      serialno.forEach(element => {
        element = element.replace(/\s/g, '');
        finalSerialNum.push(element);
        if (element == '') {
          isInvalid = true;
        }
      });
      if (isInvalid)
        this.notifierService.notify("error", "Only Spaces Entered In Serial Number.");
      else if (!isInvalid) {
        this.ordersByTripIdArray.forEach(order => {
          if (order.orderUniqueId == oid) {
            order.products.forEach(product => {
              if (product.product.productId == pid)
                product.deliveredProductSerialNumbers = finalSerialNum;
            })

            const or = Object.assign({}, order);
            orderChanged.prodQList = or.products;
            delete or.products;
            orderChanged.orderInfo = or;
          }
        })

        console.log(orderChanged);
        this.orderService.changeProductSerialNumber([orderChanged]).subscribe(changedSerialNumber => {
          console.log(changedSerialNumber);
          this.notifierService.notify("success", "Serial Number Changed Successfully.");
        })
      }
    }
  }
}